import { authAction, loginAction, logoutAction } from './authentication';
import { clearAllDataAction, loadMockDataAction } from './data';
import { consentResponseAction, consentsLoadedAction } from './consent';
import { dropboxFetchAction } from './dropbox';
import { getDatasourceStatesAction } from './dataSources';
import { fhirFetchAction } from './fhir';
import { fitFetchAction } from './google';
import { nightscoutFetchAction, nightscoutStoreAction } from './nightscout';
import { omakantaFetchAction } from './omakanta';
import { ouraFetchAction } from './oura';
import { requestAction } from './request';
import { wellmoFetchAction } from './wellmo';

const allActions = [
  authAction,
  clearAllDataAction,
  consentResponseAction,
  consentsLoadedAction,
  dropboxFetchAction,
  fhirFetchAction,
  fitFetchAction,
  getDatasourceStatesAction,
  loginAction,
  logoutAction,
  nightscoutFetchAction,
  nightscoutStoreAction,
  omakantaFetchAction,
  ouraFetchAction,
  requestAction,
  loadMockDataAction,
  wellmoFetchAction,
];

export default allActions;